import { Component, OnInit, Input } from '@angular/core';
import { IPreLog } from '../../interfaces/pre-log';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { IUser } from '../../interfaces/user';
import { Permission } from '../../interfaces/permission.enum';

@Component({
    selector: 'app-pre-log-display',
    templateUrl: './pre-log-display.component.html',
    styles: [],
    standalone: false
})
export class PreLogDisplayComponent implements OnInit {
  @Input() public preLog: IPreLog;

  public showVACORISNumber: boolean = false;

  constructor(private readonly userService: UserService) { }

  ngOnInit(): void {
    let currentUser: IUser = this.userService.getCurrentUser();
    this.showVACORISNumber = currentUser.permissions.includes(Permission.ViewVACORISNumber);
  }
  
  public renderAliases(aliases: string[]) {
    if (!aliases)
      return "";

    return aliases.join(", ");
  }

  public renderDate(date: NgbDateStruct): string {
    if (date == null)
      return "";

    return date.month + "/" + date.day + "/" + date.year;
  }
}
